import React from 'react';
import { Palette, Sun, Wand2, Scissors } from 'lucide-react';
import { siteData } from '../data/siteData';
import { Card, CardContent } from './ui/card';

const iconMap = {
  Palette: Palette,
  Sun: Sun,
  Wand2: Wand2,
  Scissors: Scissors,
};

const Services = () => {
  const colors = [
    { gradient: 'from-[var(--color-magenta)] to-[var(--color-purple)]', bg: 'bg-[var(--color-magenta)]' },
    { gradient: 'from-[var(--color-yellow)] to-[var(--color-orange)]', bg: 'bg-[var(--color-yellow)]' },
    { gradient: 'from-[var(--color-cyan)] to-[var(--color-purple)]', bg: 'bg-[var(--color-cyan)]' },
    { gradient: 'from-[var(--color-orange)] to-[var(--color-magenta)]', bg: 'bg-[var(--color-orange)]' },
  ];

  return (
    <section id="servicios" className="py-16 sm:py-24 bg-[var(--color-dark)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block px-4 py-1.5 bg-white/10 text-[var(--color-cyan)] text-sm font-medium rounded-full mb-4">
            Nuestros Servicios
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Lo que hacemos por vos
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Servicios profesionales con atención personalizada para que encuentres tu mejor versión.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {siteData.services.map((service, index) => {
            const IconComponent = iconMap[service.icon] || Scissors;
            const color = colors[index % colors.length];

            return (
              <Card
                key={service.id}
                className="group bg-white/5 border-white/10 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1 overflow-hidden"
              >
                <CardContent className="p-6 sm:p-8">
                  <div className="flex items-start gap-4">
                    <div className={`flex-shrink-0 w-16 h-16 ${color.bg} rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl sm:text-2xl font-semibold text-white mb-2">
                        {service.name}
                      </h3>
                      <p className="text-gray-400 leading-relaxed">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href={siteData.hero.cta.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[var(--color-magenta)] hover:bg-[var(--color-purple)] text-white font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
          >
            <Scissors className="w-5 h-5" />
            Consultar disponibilidad
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
